import notifyHoneybadger from 'helpers/notifyHoneybadger'
import { updateUiAction } from 'actions/uiActions'

export default errorHandler => store => next => action => {
  try {
    return next(action)
  } catch (err) {
    const state = store.getState()

    if (state.catchEarlyErrors) {
      notifyHoneybadger({ err, action: { ...action, skipThrow: true } })
      store.dispatch(updateUiAction({ modal: 'SetupProjectModal' }))
    } else notifyHoneybadger({ err, action })
  }
}



// WEBPACK FOOTER //
// ./src/helpers/errorHandler.js